import React, { useEffect, useState } from 'react';
import Loading from '../../components/ui/Loading';
import { getMsalClientId } from '../../auth/msalConfig';
import { microsoftMailAPI } from '../../api/api';
import { getMicrosoftMailAccessToken } from './microsoftMailToken';

const MailSummaryPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [summaries, setSummaries] = useState([]);
  const [infoMessage, setInfoMessage] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!getMsalClientId()) {
        if (!cancelled) {
          setError(
            'MSAL istemci kimliği tanımlı değil. .env içinde REACT_APP_MSAL_CLIENT_ID veya public/index.html içinde window.ENV.MSAL_CLIENT_ID ayarlayın.'
          );
          setLoading(false);
        }
        return;
      }

      try {
        const accessToken = await getMicrosoftMailAccessToken();
        if (cancelled) return;

        if (!accessToken) {
          setError(
            'Microsoft oturumu bulunamadı. Sol menüden Hesap sayfasına gidip Microsoft ile giriş yapın veya Modül seçiminden Mail Özeti ile tekrar deneyin.'
          );
          setLoading(false);
          return;
        }

        const data = await microsoftMailAPI.postMailSummaries(accessToken);
        if (cancelled) return;

        if (!data?.success) {
          setError(data?.message || 'Özet isteği başarısız.');
          setLoading(false);
          return;
        }

        setInfoMessage(data.message || null);
        setSummaries(Array.isArray(data.summaries) ? data.summaries : []);
      } catch (e) {
        if (!cancelled) {
          setError(e?.message || 'Beklenmeyen bir hata oluştu.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, []);

  const dismissError = () => setError(null);

  if (loading) {
    return (
      <div className="px-6 py-8">
        <Loading fullScreen={false} message="E-postalar ve özetler yükleniyor..." />
      </div>
    );
  }

  return (
    <div className="px-6 py-8 max-w-3xl">
      {error && (
        <div
          className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded dark:bg-red-900/20 dark:border-red-800 dark:text-red-300 flex justify-between items-start gap-2"
          role="alert"
        >
          <span>{error}</span>
          <button
            type="button"
            onClick={dismissError}
            className="ml-2 text-red-500 hover:text-red-700 dark:hover:text-red-400 shrink-0"
            aria-label="Kapat"
          >
            ×
          </button>
        </div>
      )}

      <h1 className="text-xl font-medium text-gray-900 dark:text-white mb-2">
        Okunmamış e-posta özeti
      </h1>
      {infoMessage && (
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">{infoMessage}</p>
      )}

      {summaries.length === 0 && !error ? (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {infoMessage || 'Özet listesi boş.'}
        </p>
      ) : (
        <ul className="space-y-4">
          {summaries.map((row, idx) => (
            <li
              key={`${row.subject}-${idx}`}
              className="bg-white dark:bg-gray-800 shadow-sm border border-gray-200 dark:border-gray-700 rounded-lg p-4"
            >
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
                {row.subject || '(Konu yok)'}
              </p>
              <p className="text-sm text-gray-900 dark:text-white">{row.summary_tr}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MailSummaryPage;
